'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logo = function (_React$PureComponent) {
  _inherits(Logo, _React$PureComponent);

  function Logo() {
    _classCallCheck(this, Logo);

    return _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).apply(this, arguments));
  }

  _createClass(Logo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: this.props.size,
          fill: this.props.fill,
          viewBox: '0 0 120.8 44.06'
        },
        _react2.default.createElement(
          'title',
          null,
          'logo plurall'
        ),
        _react2.default.createElement('path', {
          d: 'M36.07,439a11.27,11.27,0,1,1,11.27-11.27A11.28,11.28,0,0,1,36.07,439Zm0-16.61a5.34,5.34,0,1,0,5.34,5.34A5.35,5.35,0,0,0,36.07,422.41Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M113.66,439a11.27,11.27,0,1,1,11.27-11.27A11.28,11.28,0,0,1,113.66,439Zm0-16.61a5.34,5.34,0,1,0,5.34,5.34A5.35,5.35,0,0,0,113.66,422.41Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M90.17,439.21a3,3,0,0,1-3-3v-8.49a11.28,11.28,0,0,1,11.27-11.27,3,3,0,0,1,0,5.93,5.35,5.35,0,0,0-5.34,5.34v8.49A3,3,0,0,1,90.17,439.21Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M71.83,439a11.28,11.28,0,0,1-11.27-11.27,3,3,0,0,1,5.93,0,5.34,5.34,0,1,0,10.68,0,3,3,0,1,1,5.93,0A11.28,11.28,0,0,1,71.83,439Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M27.77,450.07a3,3,0,0,1-3-3V427.75a3,3,0,0,1,5.93,0V447.1A3,3,0,0,1,27.77,450.07Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M53.57,439.21a3,3,0,0,1-3-3V409a3,3,0,0,1,5.93,0v27.26A3,3,0,0,1,53.57,439.21Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M131.59,439.21a3,3,0,0,1-3-3V409a3,3,0,0,1,5.93,0v27.26A3,3,0,0,1,131.59,439.21Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M142.64,439.21a3,3,0,0,1-3-3V409a3,3,0,1,1,5.93,0v27.26A3,3,0,0,1,142.64,439.21Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M63.53,422.23a3,3,0,1,1,2.1-.87A3,3,0,0,1,63.53,422.23Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M80.14,422.23a3,3,0,1,1,2.1-.87A3,3,0,0,1,80.14,422.23Z',
          transform: 'translate(-24.8 -406.01)'
        }),
        _react2.default.createElement('path', {
          d: 'M122,439a3,3,0,0,1-3-3v-8.31a3,3,0,0,1,5.93,0v8.31A3,3,0,0,1,122,439Z',
          transform: 'translate(-24.8 -406.01)'
        })
      );
    }
  }]);

  return Logo;
}(_react2.default.PureComponent);

Logo.propTypes = {
  size: _propTypes2.default.number,
  fill: _propTypes2.default.string
};

Logo.defaultProps = {
  size: 100,
  fill: '#ffffff'
};

exports.default = Logo;